// extracted by mini-css-extract-plugin
module.exports = {"container":"forsa_container__24iQr"};